import { isValidElement } from 'react';
import { DocumentLink } from '../DocumentLink';
import { StyledDocumentListItem, StyledDocuments } from './styles';
import { DocumentListProps } from './types';

export const DocumentList = ({ documents, ...otherProps }: DocumentListProps) => {
    return (
        <StyledDocuments {...otherProps}>
            {documents.map((document, index) => {
                return (
                    <StyledDocumentListItem key={index}>
                        {isValidElement(document)
                            ? document
                            : typeof document === 'object' && (
                                  <DocumentLink {...document} href={document.href!}>
                                      {document.children}
                                  </DocumentLink>
                              )}
                    </StyledDocumentListItem>
                );
            })}
        </StyledDocuments>
    );
};
